module Blocks {
    export interface ILogger extends ng.IModule { }

    export class Logger {
        static moduleId: string = 'blocks.logger';
    }

    // Create the module and define its dependencies.
    export var logger: ILogger = angular.module(Logger.moduleId, []);

    // Execute bootstrapping code and any dependencies.
    logger.run([() => {}]);
}